import React, { useState, memo } from 'react';
import { Calendar, Star, Lightbulb } from 'lucide-react';
interface MemoryPrompt {
  question: string;
  type: 'reflection' | 'connection' | 'gratitude';
  context?: string;
}
const MemoryPrompts = () => {
  const [dailyPrompt, setDailyPrompt] = useState<MemoryPrompt>({
    question: "What's a small moment from today that made you smile?",
    type: 'reflection'
  });
  const promptCategories = [{
    icon: <Calendar className="w-6 h-6" data-id="element-163" />,
    label: "Today's Reflection",
    color: 'bg-mint-green/20 text-mint-green'
  }, {
    icon: <Star className="w-6 h-6" data-id="element-164" />,
    label: 'Memory Lane',
    color: 'bg-soft-coral/20 text-soft-coral'
  }, {
    icon: <Lightbulb className="w-6 h-6" data-id="element-165" />,
    label: 'Gratitude Corner',
    color: 'bg-lavender/20 text-lavender'
  }];
  return <div className="space-y-6" data-id="element-166">
      {/* Daily Featured Prompt */}
      <div className="bg-gradient-to-br from-mint-green/20 to-lavender/20 
        rounded-3xl p-6 shadow-soft" data-id="element-167">
        <h3 className="text-xl font-medium mb-3" data-id="element-168">Today's Gentle Reflection</h3>
        <p className="text-lg text-gray-700 dark:text-gray-200" data-id="element-169">
          {dailyPrompt.question}
        </p>
        <div className="mt-4 flex justify-end" data-id="element-170">
          <button className="btn btn-primary" data-id="element-171">Share Your Thoughts</button>
        </div>
      </div>
      {/* Prompt Categories */}
      <div className="grid grid-cols-1 gap-4" data-id="element-172">
        {promptCategories.map((category, index) => <button key={index} className={`p-4 rounded-2xl ${category.color} 
              flex items-center gap-4 transition-all
              hover:scale-[1.02] active:scale-[0.98]`} data-id="element-173">
            <div className="p-3 bg-white dark:bg-slate-800 rounded-xl" data-id="element-174">
              {category.icon}
            </div>
            <span className="text-lg font-medium" data-id="element-175">{category.label}</span>
          </button>)}
      </div>
      {/* Quick Tips */}
      <div className="bg-white dark:bg-slate-800 rounded-2xl p-4" data-id="element-176">
        <h4 className="font-medium mb-2" data-id="element-177">Memory Tips</h4>
        <ul className="space-y-2 text-gray-600 dark:text-gray-300" data-id="element-178">
          <li className="flex items-center gap-2" data-id="element-179">
            <span className="text-2xl" data-id="element-180">💭</span>
            Take a moment to breathe and reflect
          </li>
          <li className="flex items-center gap-2" data-id="element-181">
            <span className="text-2xl" data-id="element-182">📝</span>
            Write down small details that stood out
          </li>
          <li className="flex items-center gap-2" data-id="element-183">
            <span className="text-2xl" data-id="element-184">🌟</span>
            Share your memories with loved ones
          </li>
        </ul>
      </div>
    </div>;
};
export default MemoryPrompts;